let resources = [
  {
    url: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Love+Untangled+2025+_+%D0%A0%D0%B0%D1%81%D0%BF%D1%83%D1%82%D0%B0%D0%BD%D0%BD%D0%B0%D1%8F+%D0%BB%D1%8E%D0%B1%D0%BE%D0%B2%D1%8C+2025.jpeg",
    title: "Love Untangled",
    rating: 4,
    comments:
      "The plot is based on 90's where a girl with curly hair only aim to get straight hair to confess his love to the crush but life has a different plan altogether...",
  },
  {
    url: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/%E2%8A%B0_%E2%8A%B9%E0%B8%BA.jpeg",
    title: "20th Century Girl",
    rating: 3.5,
    comments:
      "Based on 90's where a girl waits for boy to meet in the 20th century. A story about frienship and love where  a high schooler finds love by accident.."
  },
  {
    url: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/2020+Movies.jpeg",
    title: "Parasite",
    rating: 5,
    comments:
      "Oscar winning movie where a poor family plans to rob a rich family and change their lives but the story is not as expected",
  },
];

function CreateCard() {
  return (
    <div style={{
      display: "flex",
      gap: "20px",
      padding: "20px",
      justifyContent: "center",
    }}>
      {resources.map((image, index) => (
        <div
          key={index}
          style={{
            backgroundColor: "#5D3954",
            height: "370px",
            width: "350px",
            borderRadius: "20px",
            padding: "15px",
            display: "flex",
            gap: "15px",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              height: "340px",
              width: "180px",
              borderRadius: "20px",
              flexShrink: 0,
              overflow: "hidden",
              backgroundColor: "#3d2436",
              position: "relative",
            }}
          >
            <img
              src={image.url}
              alt={image.title}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "20px",
                display: "block",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              padding: "5px",
              flex: 1,
            }}
          >
            <p
              style={{
                fontSize: "18px",
                color: "white",
                margin: 0,
                marginBottom: "40px",
                fontWeight: "bold",
              }}
            >
              {image.title}
            </p>
            <div
              style={{
                display: "flex",
                marginBottom: "30px",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="30"
                height="30"
                fill="gold"
              >
                <path d="M12 2l2.4 7.4h7.6l-6.2 4.5 2.4 7.4-6.2-4.5-6.2 4.5 2.4-7.4-6.2-4.5h7.6z" />
              </svg>
              <span
                style={{
                  color: "yellow",
                  fontSize: "22px",
                  fontWeight: "bold",
                }}
              >
                {image.rating}
              </span>
            </div>
            <p
              style={{
                color: "white",
                fontSize: "13px",
                lineHeight: "1.4",
                margin: 0,
                fontFamily: "Arial, sans-serif",
                textAlign: "left",
              }}
            >
              {image.comments}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
export default CreateCard;
